import Vue from "vue";
import BoardTools from "./components/BoardTools";
import ColorPicker from "./components/ColorPicker";
import PageFooter from "./components/PageFooter";
import LangPicker from "./components/LangPicker";
import SizePicker from "./components/SizePicker";
import VueDraw from "./components/VueDraw";

import { DrawingBoardVue } from "@nodopiano/vue-drawingboard";
import ElementUI from "element-ui";

import "element-ui/lib/theme-chalk/index.css";
import "vue-touch-keyboard/dist/vue-touch-keyboard.css";
import "./app.scss";

Vue.config.productionTip = false;

Vue.use(ElementUI);

Vue.component("board-tools", BoardTools);
Vue.component("color-picker", ColorPicker);
Vue.component("drawing-board-vue", DrawingBoardVue);
Vue.component("page-footer", PageFooter);
Vue.component("lang-picker", LangPicker);
Vue.component("size-picker", SizePicker);
Vue.component("vue-draw", VueDraw);

new Vue({
  render: h => h(VueDraw)
}).$mount("#app");
